export const EMPTY_VALUE = ' (empty value) ';

export enum ReleaseTypeText {
    NOT_RELEASED = 'Nicht Freigegeben',
    READY_FOR_RELEASE = 'Freigabe Vorgemerkt',
    RELEASED = 'Freigegeben',
    UNDEFINED = 'Undefined',
}
